import {
  isPlatformIconFilename,
  platformIconUrl,
} from "./platformIcons";

export const DEFAULT_FAN_CAPTURE_LABEL =
  "Stay updated with shows, music, and merch";

export const LINK_IN_BIO_SOCIAL_PLATFORMS = [
  { value: "instagram", label: "Instagram" },
  { value: "tiktok", label: "TikTok" },
  { value: "youtube", label: "YouTube" },
  { value: "spotify", label: "Spotify" },
  { value: "apple-music", label: "Apple Music" },
  { value: "twitter", label: "X" },
  { value: "facebook", label: "Facebook" },
  { value: "twitch", label: "Twitch" },
] as const;

export type LinkInBioSocialPlatform =
  (typeof LINK_IN_BIO_SOCIAL_PLATFORMS)[number]["value"];

export const LINK_IN_BIO_SOCIAL_PLATFORM_VALUES = new Set<string>(
  LINK_IN_BIO_SOCIAL_PLATFORMS.map((platform) => platform.value)
);

export function linkInBioSocialPlatformLabel({
  platform,
}: {
  platform: string;
}): string {
  return (
    LINK_IN_BIO_SOCIAL_PLATFORMS.find((entry) => entry.value === platform)
      ?.label ?? platform
  );
}

export function linkInBioSocialIconUrl({
  platform,
}: {
  platform: string;
}): string | undefined {
  const icon = `${platform}.png`;
  if (!isPlatformIconFilename(icon)) {
    return undefined;
  }
  return platformIconUrl({ icon });
}
